import React, { type ReactNode } from 'react';

const styleFullHeight = {
	height: '100vh',
} as const;

export const FullHeight = ({ children }: { children: ReactNode }) => (
	// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
	<div style={styleFullHeight}>{children}</div>
);
